/** Column widths of referral_partner, mirrored by @Size on the backend request records. */
export const PARTNER_FIELD_MAX_LENGTH = {
  fullName: 255,
  displayName: 255,
  tradingName: 255,
  phone: 64,
  entityType: 32,
  abn: 32,
  addressLine1: 255,
  addressLine2: 255,
  suburb: 128,
  state: 64,
  postcode: 16,
  country: 64,
  bankAccountName: 255,
  bsb: 16,
  accountNumber: 64,
};

export const AU_STATES = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
